export default [
  {
    id: 1,
    key: 'APPLE',
    value: '苹果'
  },
  {
    id: 2,
    key: 'HUAWEI',
    value: '华为'
  },
  {
    id: 3,
    key: 'XIAOMI',
    value: '小米'
  },
  {
    id: 4,
    key: 'SAMSUNG',
    value: '三星'
  },
  {
    id: 5,
    key: 'OPPO',
    value: 'OPPO'
  },
  {
    id: 6,
    key: 'VIVO',
    value: 'VIVO'
  },
  {
    id: 7,
    key: 'MEIZU',
    value: '魅族'
  },
  {
    id: 8,
    key: 'GIONEE',
    value: '金立'
  },
  {
    id: 9,
    key: 'COOLPAD',
    value: '酷派'
  },
  {
    id: 10,
    key: 'LENOVO',
    value: '联想'
  },
  {
    id: 11,
    key: 'LETV',
    value: '乐视'
  },
  {
    id: 12,
    key: 'ZTE',
    value: '中兴'
  },
  {
    id: 13,
    key: 'CHINAMOBILE',
    value: '中国移动'
  },
  {
    id: 14,
    key: 'HTC',
    value: 'HTC'
  },
  {
    id: 15,
    key: 'PEPPER',
    value: '小辣椒'
  },
  {
    id: 16,
    key: 'NUBIA',
    value: '努比亚'
  },
  {
    id: 17,
    key: 'HISENSE',
    value: '海信'
  },
  {
    id: 18,
    key: 'QIKU',
    value: '奇酷'
  },
  {
    id: 19,
    key: 'TCL',
    value: 'TCL'
  },
  {
    id: 20,
    key: 'SONY',
    value: '索尼'
  },
  {
    id: 21,
    key: 'SMARTISAN',
    value: '锤子手机'
  },
  {
    id: 22,
    key: '360',
    value: '360 手机'
  },
  {
    id: 23,
    key: 'ONEPLUS',
    value: '一加手机'
  },
  {
    id: 24,
    key: 'LG',
    value: 'LG'
  },
  {
    id: 25,
    key: 'MOTO',
    value: '摩托罗拉'
  },
  {
    id: 26,
    key: 'NOKIA',
    value: '诺基亚'
  },
  {
    id: 27,
    key: 'GOOGLE',
    value: '谷歌'
  }
]
